import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

export function changeFavicon(src) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = src;
}

class FaviconManager extends Component {
  componentDidMount() {
    this.updateFavicon();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.updateFavicon();
    }
  }

  updateFavicon() {
    let { pathname } = this.props.location;

    // Remove o idioma (/pt, /en, etc.)
    const parts = pathname.split('/');
    if (parts.length > 2) {
      pathname = '/' + parts.slice(2).join('/');
    }

    if (pathname.startsWith('/form/')) {
      changeFavicon('/favicon.png');
    } else {
      changeFavicon('/speed_me_favicon.png');
    }
  }

  render() {
    return null;
  }
}

export default withRouter(FaviconManager);
